import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

// Import API URL from utility
import { API_URL } from '../lib/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Get session_id from URL fragment
        const hash = window.location.hash;
        console.log('Auth callback - hash:', hash);
        const sessionId = hash.split('session_id=')[1]?.split('&')[0];
        console.log('Auth callback - sessionId:', sessionId);

        if (!sessionId) {
          console.error('No session_id found in URL');
          navigate('/login');
          return;
        }

        console.log('Exchanging session_id for user data at:', `${API_URL}/api/auth/session`);
        // Exchange session_id for user data
        const response = await axios.post(
          `${API_URL}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        console.log('Auth session response:', response.data);

        if (response.data) {
          // Get the session token from the response or generate fallback
          const sessionToken = response.data.session_token || sessionId;
          console.log('Session token:', sessionToken);
          updateUser(response.data, sessionToken);
          
          // Store token in localStorage as fallback
          localStorage.setItem('session_token', sessionToken);
          
          // Clear the hash and redirect to dashboard
          window.history.replaceState(null, '', '/dashboard');
          navigate('/dashboard', { state: { user: response.data }, replace: true });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        console.error('Error response:', error.response?.data);
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, updateUser]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-sky-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-20 h-20 mx-auto mb-6 bg-white rounded-full shadow-lg flex items-center justify-center">
          <Loader2 className="w-10 h-10 text-coral-500 animate-spin" />
        </div>
        <h2 className="text-2xl font-bold text-slate-800 mb-2">Signing you in...</h2>
        <p className="text-slate-600">Just a moment while we prepare your adventure!</p>
        
        {/* Fun animated elements */}
        <div className="mt-8 flex justify-center gap-2">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="w-3 h-3 bg-coral-400 rounded-full animate-bounce"
              style={{ animationDelay: `${i * 0.2}s` }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
